import { Grid, Box, makeStyles } from "@material-ui/core";

import {
  AddStates,
  FormikTextField,
  FormikAddHoursOfOperations,
  Fieldset
} from "Shared";
import {
  SectionContainer,
  AddOrgNpiAndTaxId
} from "AffiliationValidation/components";
import { OperationHourType } from "Shared/graphql/generated";

const useStyles = makeStyles({
  gridItem: {
    marginBottom: "8px"
  }
});

export const VerifyWorkOrganization: React.FC = () => {
  const { gridItem } = useStyles();

  return (
    <SectionContainer label="Verify work organization details:">
      <Box component={(props) => <Fieldset {...props} />}>
        <Grid container spacing={2}>
          <Grid item xs={12} className={gridItem}>
            <FormikTextField
              required
              name="orgName"
              label="Organization Name"
            />
          </Grid>
          <Grid item xs={12} className={gridItem}>
            <FormikTextField name="orgAddressLine1" label="Address Line 1" />
          </Grid>
          <Grid item xs={12} className={gridItem}>
            <FormikTextField
              name="orgAddressLine2"
              label="Address Line 2 (Suite, Floor, etc.)"
            />
          </Grid>
          <Grid item xs={4}>
            <FormikTextField name="orgAddressLocality" label="City" />
          </Grid>
          <Grid item xs={4}>
            <AddStates name="orgAddressRegion" />
          </Grid>
          <Grid item xs={4}>
            <FormikTextField name="orgAddressPostalCode" label="Zip Code" />
          </Grid>
          <Grid item xs={12}>
            <AddOrgNpiAndTaxId />
          </Grid>
          <Grid item xs={12}>
            <FormikAddHoursOfOperations type={OperationHourType.Organization} />
          </Grid>
        </Grid>
      </Box>
    </SectionContainer>
  );
};
